import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PrimaryButton } from "../../components/Buttons/PrimaryButton";
import {
  SecondaryAreaButton,
  SecondaryButton,
} from "../../components/Buttons/SecondaryButton";
import { Page } from "../../components/Page";
import { Table } from "../../components/Table";
import { request } from "../../services/request";

interface IClient {
  name: string;
}

export const Clients: React.FC = () => {
  const [clients, setClients] = useState<Array<IClient>>([]);
  const history = useHistory();

  const gotToPage = (route: string) => {
    history.push(route);
  };

  const columns = [
    {
      name: "name",
      label: "name",
    },
    {
      name: "_id",
      label: "Ações",
      options: {
        filter: false,
        customBodyRender: (v: string) => {
          return (
            <SecondaryAreaButton>
              <SecondaryButton
                onClick={() => gotToPage(`clientes/${v}/tabulacoes`)}
              >
                tabulações
              </SecondaryButton>
              <SecondaryButton onClick={() => gotToPage(`clientes/${v}/filas`)}>
                fila
              </SecondaryButton>
            </SecondaryAreaButton>
          );
        },
      },
    },
  ];

  const getClients = async () => {
    const response = await request({
      method: "GET",
      path: "clients?minimum=true",
      showSuccessMessage: false,
    });

    if (!response.error) {
      setClients(response);
    }
  };

  const handleNeUser = () => {
    history.push("/clientes/novo");
  };

  useEffect(() => {
    getClients();
  }, []);

  return (
    <Page header="Clientes">
      <PrimaryButton text="+ novo cliente" onClick={handleNeUser} />
      <Table columns={columns} title="" data={clients} />
    </Page>
  );
};
